import React from 'react';
import PropTypes from 'prop-types';
import { browserHistory } from 'react-router'

const propTypes = {
    errorPageClass: PropTypes.string,
    errorImage: PropTypes.object,
    errorTitle: PropTypes.string,
    errorBodyText: PropTypes.string,
    errorButtonTxt: PropTypes.string
};

const defaultProps = {
    errorPageClass: 'error',
    errorTitle: 'Please Bear With Us',
    errorBodyText: 'It\'s not you. It\'s us. We wandered down the wrong path and can\'t seem to find the page you\'re looking for. Click the button below to go back to the previous page.',
    errorButtonTxt: 'Go Back'
};

export default class NotFoundPage extends React.Component {
    render() {
        return (
            <div className={`rec-error-wrap ${this.props.errorPageClass}`}>
                <div className="rec-error-body-wrap">
                    <h1>{this.props.errorTitle}</h1>
                    <p>{this.props.errorBodyText}</p>
                    <button
                        className="rec-button-primary"
                        type="button"
                        title={this.props.errorButtonTxt}
                        aria-label={this.props.errorButtonTxt}
                        onClick={browserHistory.goBack}>
                        {this.props.errorButtonTxt}
                    </button>
                </div>
            </div>
        );
    }
}

NotFoundPage.propTypes = propTypes;
NotFoundPage.defaultProps = defaultProps;
